import { toWire } from '@powerduck/common/extensions/temporal-extensions';
import TemporalUtils from '@powerduck/common/utils/temporal-utils';

export const serializeInviton = Symbol('serializeInviton');

function serializeInvitonImpl(this: Temporal.PlainDateTime): string {
	return this[toWire](true);
}

export function fromInviton(val: string): Temporal.PlainDateTime {
	return TemporalUtils.fromString(val);
}

declare global {
	// eslint-disable-next-line ts/no-namespace
	namespace Temporal {
		interface PlainDateTime {
			[serializeInviton]: typeof serializeInvitonImpl;
		}
	}
}

export const applyInvitonTemporalExtensions = (): void => {
	if (typeof Temporal === 'undefined') {
		return;
	}

	(Temporal.PlainDateTime.prototype as any)[serializeInviton] = serializeInvitonImpl;
};

applyInvitonTemporalExtensions();
